import { render, staticRenderFns } from "./TheIndexCategoriaLinae.vue?vue&type=template&id=aa6de684&"
import script from "./TheIndexCategoriaLinae.vue?vue&type=script&lang=js&"
export * from "./TheIndexCategoriaLinae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports